//TODO: envファイルを見るべき
const hostName = window.location.hostname;

export const isProd = hostName.includes("mingaku.net");
export const isStg = hostName.includes("mingaku-stg-hhgg9se.com");
export const isDev = hostName.includes(
  "localhost || 127.0.0.1 || mingaku-dev-j82s7q6.com"
);

export class Domains {
  private usePrefix = false;
  constructor({ usePrefix: _usePrefix }: { usePrefix?: boolean }) {
    if (_usePrefix) {
      this.usePrefix = _usePrefix;
    }
  }

  get domains(): {
    admin: string;
    app: string;
    schoolAi: string;
  } {
    const _domains = {
      dev: {
        admin: "admin.mingaku-dev-j82s7q6.com",
        app: "app.mingaku-dev-j82s7q6.com",
        schoolAi: "school-ai.mingaku-dev-j82s7q6.com"
      },
      stg: {
        admin: "admin.mingaku-stg-hhgg9se.com",
        app: "app.mingaku-stg-hhgg9se.com",
        schoolAi: "school-ai.mingaku-stg-hhgg9se.com"
      },
      prod: {
        admin: "admin.mingaku.net",
        app: "app.mingaku.net",
        schoolAi: "school-ai-app.mingaku.net"
      }
    };

    const domainsOfEnv = _domains[isProd ? "prod" : isStg ? "stg" : "dev"];
    if (this.usePrefix) {
      for (const key in domainsOfEnv) {
        domainsOfEnv[key as keyof typeof domainsOfEnv] =
          "https://" + domainsOfEnv[key as keyof typeof domainsOfEnv];
      }
    }

    return domainsOfEnv;
  }
}
